import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiClient } from "../../api/api";
import { defaultRadioInfoByType } from "../../utils/constants";
import { fetchTrackDataApi } from "./playerSlice";

export const rateTrackApi = createAsyncThunk(
  "radioInfo/rateTrackApi",
  async ({ rating, trackId, type }, storeAPI) => {
    await apiClient.post(`track/rate`, { rating, track_id: trackId });
    storeAPI.dispatch(fetchTrackDataApi({ type, trackId }));
  },
);

export const radioInfoSlice = createSlice({
  name: "radioInfo",
  initialState: defaultRadioInfoByType,
  reducers: {
    setCurrentTrack: (state, action) => {
      state[action.payload.type].currentTrack = action.payload.message;
    },
    setPlay: (state, action) => {
      state[action.payload.type].isPlaying = action.payload.play;
    },
    setLoading: (state, action) => {
      state[action.payload.type].loading = action.payload.loading;
    },
  },
});

export const { setCurrentTrack, setPlay, setLoading } = radioInfoSlice.actions;

export default radioInfoSlice.reducer;
